module.exports = __webpack_public_path__ + "static/media/stages.a8ec175d.svg";